// Performance monitoring utility for dashboard optimization
class PerformanceMonitor {
  constructor() {
    this.metrics = {
      apiCalls: new Map(),
      requestTimes: [],
      cacheHits: 0,
      cacheMisses: 0,
      batchedRequests: 0,
      individualRequests: 0
    }
    this.startTime = Date.now()
  }

  trackApiCall(endpoint, duration, cached = false) {
    const key = endpoint.split('/').pop() || endpoint
    
    if (!this.metrics.apiCalls.has(key)) {
      this.metrics.apiCalls.set(key, { count: 0, totalTime: 0, avgTime: 0 })
    }
    
    const metric = this.metrics.apiCalls.get(key)
    metric.count++
    metric.totalTime += duration
    metric.avgTime = metric.totalTime / metric.count
    
    this.metrics.requestTimes.push({ endpoint: key, duration, timestamp: Date.now(), cached })
    
    if (cached) {
      this.metrics.cacheHits++
    } else {
      this.metrics.cacheMisses++
    }
  }

  trackBatchRequest(summaryIds) {
    this.metrics.batchedRequests++
    console.log(`🚀 Batched ${summaryIds.length} summary requests`)
  }

  trackIndividualRequest() {
    this.metrics.individualRequests++
  }

  getStats() {
    const totalRequests = this.metrics.cacheHits + this.metrics.cacheMisses
    const cacheHitRate = totalRequests > 0 ? (this.metrics.cacheHits / totalRequests * 100).toFixed(1) : 0
    const uptime = Math.round((Date.now() - this.startTime) / 1000)
    
    return {
      uptime: `${uptime}s`,
      totalRequests,
      cacheHitRate: `${cacheHitRate}%`,
      batchedRequests: this.metrics.batchedRequests,
      individualRequests: this.metrics.individualRequests,
      apiCalls: Object.fromEntries(this.metrics.apiCalls),
      recentRequests: this.metrics.requestTimes.slice(-10)
    }
  }

  logStats() {
    const stats = this.getStats()
    console.group('📊 Dashboard Performance Stats')
    console.log('Uptime:', stats.uptime)
    console.log('Total Requests:', stats.totalRequests)
    console.log('Cache Hit Rate:', stats.cacheHitRate)
    console.log('Batched Requests:', stats.batchedRequests)
    console.log('Individual Requests:', stats.individualRequests)
    console.log('API Calls by Endpoint:', stats.apiCalls)
    console.groupEnd()
  }

  // Auto-log stats every 30 seconds in development
  startAutoLogging() {
    if (process.env.NODE_ENV === 'development') {
      setInterval(() => {
        this.logStats()
      }, 30000)
    }
  }
}

// Create singleton instance
const performanceMonitor = new PerformanceMonitor()

// Start auto-logging in development
if (process.env.NODE_ENV === 'development') {
  performanceMonitor.startAutoLogging()
}

export default performanceMonitor